import type { Middleware } from '@reduxjs/toolkit';
import { isRejected } from '@reduxjs/toolkit';

import { quotesApi } from '../services/quotes';
import { genericDecline } from '../slices/decline';
import { isPaymentErrorRetry } from '../thunks/error';
import { logError } from '../utils/logError';
import { isConditionError } from '../utils/rtkQueryErrors';

export const errorHandlerMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (quotesApi.endpoints.getQuote.matchRejected(action)) {
      return next(action);
    }
    if (isRejected(action)) {
      // Ignore these errors as they are handled in thunks
      if (isPaymentErrorRetry(action)) {
        return next(action);
      }

      if (isConditionError(action)) {
        return next(action);
      }

      dispatch(genericDecline(typeof action.payload === 'string' ? action.payload : undefined));
      quotesApi.endpoints.getQuote.matchRejected(action);
      logError({
        message: 'Middleware error: API request failed',
        ...action,
      });
    }

    return next(action);
  };
